/* eslint 'no-self-assign': "off", 'no-unused-vars':"off" */
import React, { useState, useCallback, useEffect, useRef } from "react";
import { Col, FormGroup, Form, Modal, Label, Table } from "reactstrap";
import CreateSecureConnect from "./AddSecureConnect";
import CreateNode from "./Node/CreateNode";
import ViewNodeDetails from "./Node/ViewNodeDetails";
import { withRouter } from 'react-router-dom';
import { GetNetworkListData } from 'action/secureconnectAction';
import { setAmplitudeEvent } from 'amplitude/amplitude';
import { useDispatch, useSelector } from "react-redux";
import { FormErrorContainer, ErrorSection } from "components/EnsembleComponents/BACNetComponents/_ModalForms/ViewHubParameters/styled";
import { MdWarning, MdClose } from "react-icons/md";
import Spinner from "components/common/LegacySpinner";
import {
    SpinnerContainer, CloseButton, SaveButton, StyledHRColumn, ErrorMessage,// HubStatusWarning,
    ActionItemsContainer, DeleteIconWrapper
} from "./styled";
import { BsTrash } from "react-icons/bs";
import { ModelBodyDiv, HeaderTitle } from "components/EnsembleComponents/BACNetComponents/_ModalForms/ManageSignCertificate/styled";
import { useSecureNetworkAPIMethods, useGetLocalizationLabel, useFetchHubParamsData } from "./useAPIMethods";
import { FaArrowLeft } from "react-icons/fa";
import ReactPaginate from 'react-paginate';
import { Icon } from 'semantic-ui-react';
import InactiveWindow from '../../../../Logout/InActive';
import Idle from 'react-idle';
// import { hubDisabledWarning } from "./constants";
const KEYS_TO_FILTERS = ['networkName', 'isNodeConnected', 'mode', 'siteName', 'endPointUrl'];

export function usePrevious(value) {
        const ref = useRef();
        useEffect(() => {
            ref.current = value;
        },[value]);
        return ref.current;
}

const ManageSecureConnect = ({ history, className }) => {
    const dispatch = useDispatch();
    const networkList = useSelector(state => state.HubManagementRootReducer.GetNetworkList);
    const [state, setState] = useState({
        modal: false,
        networkID: 0,
        redirect: false,
        apiError: "",
        loading: true,
        deleteItem: null,
        IsCreateNode: false,
        IsViewNode: false,
        searchTerm: '',
        pageSize: 50,
        currentPage: 0,
        IsDefaultSort: true,
        sort: {
            column: null,
            direction: [
                { name: 'networkName', direction: 'asc', onclick: true },
                { name: 'isNodeConnected', direction: 'desc', onclick: false },
                { name: 'mode', direction: 'desc', onclick: false },
                { name: 'siteName', direction: 'desc', onClick: false },
                { name: 'endPointUrl', direction: 'desc', onClick: false }
            ]
        },
        networkListData: [],
        connectionStatus: '',
        inactive_modal: false,
        LogOffTime: 1200000,
    });
    const prevNetworkListData = usePrevious(state.networkListData);
    const getNetworkList = (suppressError) => {
        dispatch(GetNetworkListData((apiStatus, errorDetails) => getNetworkListCallBack(apiStatus, errorDetails, suppressError)));
    }
    const { deleteSecureNetwork } = useSecureNetworkAPIMethods(setState, getNetworkList);
    const { getLabel } = useGetLocalizationLabel();
    const { refetch, data } = useFetchHubParamsData(history);
    let lNetworklength = 0, lCurrentNetworklength = 0, pagesCount = 0;

    // **** For componentDidMount method ***** //
    useEffect(() => {
        setAmplitudeEvent("ManageSecureConnectPage", { "user": "admin", "action": "Navigated to Manage Secure Connect page" });
        getNetworkList();
        var E_LogoffTime = localStorage.getItem("AutoLogoffTime");
        if (E_LogoffTime !== undefined && E_LogoffTime !== null && E_LogoffTime !== "") {
           setState(prevState => ({...prevState, LogOffTime : Number(E_LogoffTime) }));
        }
        const fetchUpdatedData = setInterval(() => {
            getNetworkList(true);
            refetch({}, true);
        }, 10000);
        return () => {
            clearInterval(fetchUpdatedData);
        }
    }, []);


    useEffect(() => {
        if(networkList !== null && networkList !== undefined){
            let structuredData = []
            networkList.forEach(el => {
                var lineitem = {
                    "networkID": el.networkID,
                    "networkName": el.networkName,
                    //"isNodeConnected": el.isNodeConnected ? "Connected" :  !el.isEnabled ? "Disabled" : el.isEnabled && el.hasCertificates ? "Connected to Primary Hub" : "Enabled",
                    "isNodeConnected": getConnectionStatus(el),
                    "mode": getLabel("CreateNode." + el.mode) ? getLabel("CreateNode." + el.mode) : "Node",
                    "siteName": el.siteName ? el.siteName : "--",
                    "endPointUrl": el.endPointUrl ? el.endPointUrl : "--",
                }
                structuredData.push(lineitem);
            })
            setState(prevState => ({...prevState, networkListData: structuredData}))
        }
    },[networkList])

    const getConnectionStatus = (el) => {
        let ConnectionStatus = "";
        if (!el.isEnabled) {
            ConnectionStatus = "Disabled"
        } else {
            if (el.mode === 0) { //Node
                if (el.isEnabled && el.isNodeConnected && el.hasCertificates && el.connectionName !== null && el.connectionName.toLowerCase() === "failover")
                    ConnectionStatus = "Connected to Failover Hub"
                else if (el.isEnabled && el.isNodeConnected && el.hasCertificates)
                ConnectionStatus = "Connected to Primary Hub"
                else if (el.isEnabled && !el.isNodeConnected && el.hasCertificates)
                    ConnectionStatus = "Offline"                
                else if (el.isEnabled && !el.isNodeConnected && !el.hasCertificates)
                    ConnectionStatus = "Enabled"
            } else { //Node + Hub, Node + Hub + CA
                if (el.mode === 1 && el.isEnabled && !el.hasCertificates)
                    ConnectionStatus = "Enabled"
                else if (el.isEnabled && el.isNodeConnected && el.connectedDeviceCount > 0)
                    ConnectionStatus = el.connectedDeviceCount + " Devices Connected"
                else if (el.isEnabled && el.isNodeConnected && el.connectedDeviceCount === 0 && el.connectionName !== null && el.connectionName.toLowerCase() === "failover")
                    ConnectionStatus = "Connected to Failover Hub"
                else if (el.isEnabled && el.isNodeConnected && el.connectedDeviceCount === 0)
                    ConnectionStatus = "Connected to Primary Hub"               
                else if (el.isEnabled && !el.isNodeConnected && (el.connectedDeviceCount === 0 || el.connectedDeviceCount > 0))
                    ConnectionStatus = "Offline"
            }
        }
        return ConnectionStatus;
    }
    
    useEffect(() => {
        if (state.deleteItem) {
            setState(prevState => ({
                ...prevState,
                modal: true,
            }));
        }
    }, [state.deleteItem]);

    /* search System fetching value*/
    const searchUpdated = (term) => {
        setState(prevState => ({
            ...prevState,
            searchTerm: term.target.value,
            currentPage: 0
        }));
    }

    const handlePageClick = (data) => {
        let selected = data.selected;
        setState(prevState => ({
            ...prevState,
            currentPage: selected
        }));
        var scrollPageTop = document.getElementsByClassName('Ensemble_Content_FullPage');
        if (scrollPageTop[0] !== undefined) {
            scrollPageTop[0].scrollIntoView()
        }
    }

    const getNetworkListCallBack = (status, errorDetails, suppressError) => {
        if (suppressError) {
            setState(prevState => ({ ...prevState, loading: false }));
        } else {
            setState(prevState => ({ ...prevState, apiError: status === "error" ? errorDetails.message : "", loading: false }));
        }
    }

    const viewNetworkDetailsLink = useCallback((networkId, networkName, ConnectionStatus, ensembleVmac) => {
        //sessionStorage.setItem("retrieveNetworkID", networkId);
        //sessionStorage.setItem("retrieveNetworkName", networkName);
        //history.push(`/ConnectedNodeDevices/${networkName}`);
        sessionStorage.setItem("ensembleVmac", ensembleVmac);
        setState(prevState => ({
            ...prevState,
            IsViewNode: !prevState.IsViewNode,
            networkID: networkId,
            connectionStatus: ConnectionStatus
        }));
    }, []);

    const wrapperPopupCancel = () => {
        setState(prevState => ({
            ...prevState,
            modal: false,
            redirectHome: true
        })); 
    }

    const toggle = () => {
        setState(prevState => ({
            ...prevState,
            modal: !prevState.modal,
            deleteItem: null
        }));
    }

    const RedirectToCreateNode = () => {
        setState(prevState => ({
            ...prevState,
            IsCreateNode: !prevState.IsCreateNode
        }));
    }

    const onClickDeleteYes = () => {
        if (state.deleteItem) {
            deleteSecureNetwork(state.deleteItem.networkID);
        }
    }

    const getDeleteWarningMessage = () => {
        if (state.deleteItem && state.deleteItem.isNodeConnected && (state.deleteItem.isNodeConnected === "Disabled" || state.deleteItem.isNodeConnected === "Offline" || state.deleteItem.isNodeConnected === "Enabled")) {
            return <p>{getLabel("DeleteWarningMessage2") ? getLabel("DeleteWarningMessage2") : "Are you sure you want to delete the BACnet Secure Network ?"}</p>;
        } else {
            return <>
                <p>{getLabel("DeleteWarningMessage1") ? getLabel("DeleteWarningMessage1") : "There are 1 or more devices connected to the BACnet Secure Network. If you delete the network, configuration changes will be required for the device."}</p>
                <p>{getLabel("DeleteWarningMessage2") ? getLabel("DeleteWarningMessage2") : "Are you sure you want to delete the BACnet Secure Network ?"}</p>
            </>;            
        }
    }

    const deleteWarningPopup = () => {
        return (
            <ModelBodyDiv>
                <HeaderTitle id="header-title">
                    <label>{getLabel("DeleteModalTitle") ? getLabel("DeleteModalTitle") : "Delete BACnet Secure Network"}</label>
                </HeaderTitle>
                <StyledHRColumn sm={{ size: 12 }} ml="0px">
                    <hr />
                </StyledHRColumn>
                <ErrorMessage>
                    {
                        getDeleteWarningMessage()
                    }
                </ErrorMessage>
                <CloseButton id="cancel-button" onClick={toggle} variant="contained">{getLabel("Cancel") ? getLabel("Cancel") : "Cancel"}</CloseButton>
                <SaveButton  id="delete-button" primary variant="contained" onClick={onClickDeleteYes}>{getLabel("Delete") ? getLabel("Delete") : "Delete"}</SaveButton>
            </ModelBodyDiv>
        );
    }

    const onClickDelete = (objectData) => {
        setState(prevState => ({ ...prevState, deleteItem: objectData }));
    }

    const OnCancel = () => {
        setState(prevState => ({
            ...prevState,
           IsCreateNode: !prevState.IsCreateNode,
        }));
    }

    const handleCancel = () => {
        setState(prevState => ({
            ...prevState,
            IsViewNode: !prevState.IsViewNode
        }))
    }
    const onSort = (column) => {
        setState(prevState => ({
            ...prevState,
            IsDefaultSort: false
        }));
        var SortData = state.sort.direction;
        var selected = SortData.filter(a => a.name === column);
        const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = state.networkListData;
        let notequals = 0;
        let sortedData;
        if (data_from_state != null && column !== "mode") {
            sortedData = data_from_state.sort((a, b) => {
                let nameA = a[column].toLowerCase();
                let nameB = b[column].toLowerCase();

                if (nameA < nameB) {
                    notequals = 1;
                    return -1;
                }
                if (nameA > nameB) {
                    notequals = 1;
                    return 1;
                }
                if (nameA === nameB) {
                    return 0;
                }
                return 0;
            });
        }
        if (data_from_state != null && column === "mode") {
            sortedData = data_from_state.sort((a, b) => {
                let nameA = a[column];
                let nameB = b[column];

                if (nameA < nameB) {
                    notequals = 1;
                    return -1;
                }
                if (nameA > nameB) {
                    notequals = 1;
                    return 1;
                }
                if (nameA === nameB) {
                    return 0;
                }

                return 0;
            });
        }
        if (selected[0].direction === 'asc' && notequals === 1) {
            sortedData.reverse();
        }

        const array = state.sort.direction;
        array.map(x => (x.name === column) ? x.onclick = true : x.onclick = false);
        array.map(x => (x.name === column) ? x.direction = direction : x.direction = x.direction);

        setState(prevState => ({
            ...prevState,
            sort: {
                column,
                direction: array
            }
        }));
    };

    const Inactivetoggle = () => {
       setState(prevState => ({
            ...prevState,
            inactive_modal: !state.inactive_modal,
       }))
    }

    const Extend_Session = (someArg) => {
        Inactivetoggle();
    }

    const sorting = (data, column, direction) => {
        let sortedData = data.sort((a, b) => {
            let nameA = column === 'mode' ? a[column] : a[column].toLowerCase();
            let nameB = column === 'mode' ? b[column] : b[column].toLowerCase();
            if(nameA < nameB) {
                return -1;
            }
            if(nameA > nameB) {
                return 1;
            }
            if(nameA === nameB) {
                return 0;
            }
            return 0;
        });
        if (direction === 'desc') {
            sortedData.reverse();
        }   
        return sortedData;
    }

    function FormTableData() {
        let FilteredData = state.networkListData;
        if(prevNetworkListData !== state.networkListData){
            if(state.IsDefaultSort){
                sorting(FilteredData, 'networkName', 'asc');
            }
            if(!state.IsDefaultSort && state.sort.column !== null){
                var column = state.sort.column;
                var direction = state.sort.direction.filter(x => x.name === column)[0].direction;
                sorting(FilteredData, column, direction);
            }
        }
        if (FilteredData.length && state.searchTerm ){
            const networkList = FilteredData.map(({networkID, ...rest}) => rest);
            FilteredData = networkList.filter(item => (Object.values(item).join(' ').toLowerCase().includes(state.searchTerm.toLowerCase())));
            FilteredData = FilteredData.map(e => ({...e,"networkID":state.networkListData.filter(i => i.networkName === e.networkName)[0].networkID}));
        }
        return (  
            <>  
                {
                    FilteredData && FilteredData.length ? FilteredData.slice(state.currentPage * state.pageSize, (state.currentPage + 1) * state.pageSize).map(el => (
                        <tr key={el.networkID}>
                            <td style={{ padding: "10px" }}>
                                <label id="network-link" style={{ color: '#6890c6', marginBottom: "0" }} onClick={() => viewNetworkDetailsLink(el.networkID, el.networkName, el.isNodeConnected, ensembleVmac)} className="link_cursor">{el.networkName}</label>
                            </td>
                            {   el.isNodeConnected !== "Enabled" ? 
                                <td >{el.isNodeConnected}</td> : <td >{"Enabled"} 
                                    <Icon name='exclamation triangle' style={{ 'color': 'red', 'padding-left': '8px', 'padding-right': '14px', 'padding-top': '0px' }} /> 
                                    <Label style={{ 'color': 'red' }} >missing certificates</Label>
                                    </td>
                            }
                            <td>{el.mode}</td>
                            <td>{el.siteName}</td>
                            <td>{el.endPointUrl}</td>
                            <td style={{pointerEvents: (el.siteName !== '--') ? "none" : "auto"}}> 
                                <DeleteIconWrapper id="trash-button" onClick={() => onClickDelete(el)} title="Delete certificate" disabled={el.siteName !== "--"}>
                                    <BsTrash />
                                </DeleteIconWrapper>
                            </td>
                        </tr>)) : <tr> <td colSpan="5" style={{ textAlign: "center" }}>{getLabel("NoRecords") ? getLabel("NoRecords") : "No Records Found"}</td> </tr>
                }
            </>
        )
    }

    function GetPaginationText() {
        let FilteredData = state.networkListData && state.networkListData.length && state.networkListData.map(({networkID, ...rest}) => rest).filter(item => (Object.values(item).join(' ').toLowerCase().includes(state.searchTerm.toLowerCase())));
        if (FilteredData && FilteredData.length) {
            lNetworklength = FilteredData.length;
            pagesCount = Math.ceil(FilteredData.length / state.pageSize);
            lCurrentNetworklength = FilteredData.slice(state.currentPage * state.pageSize, (state.currentPage + 1) * state.pageSize).length;
        }
        return (lNetworklength !== 0 ? state.currentPage * 50 + 1 : 0) + "-" + ((state.currentPage * 50) + lCurrentNetworklength) + " of " + lNetworklength + " records"
    }

    // const isHubDisabled = hubParamDetails && hubParamDetails.isHubServerEnabled !== undefined && !hubParamDetails.isHubServerEnabled;
    const ensembleVmac = (data && data.vmac !== undefined) ?  data.vmac : ""; 
    
    return (
        <div className="main_container">
            {state.IsCreateNode ? <CreateNode networkList={networkList} OnCancel={OnCancel} getNetworkList={getNetworkList} /> :
            state.IsViewNode ? <ViewNodeDetails networkList={networkList} networkId={state.networkID} OnCancel={handleCancel} getNetworkList={getNetworkList} connectionStatus={state.connectionStatus}/> :
                <>
                    <Form>
                        <FormGroup row style={{ "margin-bottom": "1px" }}>
                            <Col sm={{ size: 4 }}>
                                <Label className='workordermainheaderlbl' id="networklist-headerlabel">{getLabel("HeaderTitle") ? getLabel("HeaderTitle") : "Manage Secure Connect BACnet Network"}</Label>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Col sm={{ size: 6 }}>
                            <ActionItemsContainer sm={{ size: 12 }} style={{"padding-left":"0px"}}>
                                <SaveButton
                                    onClick={RedirectToCreateNode}
                                    // disabled={isHubDisabled}
                                    id="create-button"
                                    primary
                                    ml="0px">
                                    {getLabel("Create") ? getLabel("Create") : "Create"}
                                </SaveButton>
                                {/* {
                            isHubDisabled ? <HubStatusWarning>
                                <MdWarning />
                                <p>{ getLabel("hubDisabledWarning") ? getLabel("hubDisabledWarning") : hubDisabledWarning }</p>
                            </HubStatusWarning> : null
                        } */}
                                <Modal
                                    isOpen={state.modal}
                                    toggle={toggle}
                                    className={className}
                                >
                                    {
                                        state.deleteItem !== null ? deleteWarningPopup() : <CreateSecureConnect
                                            onPopupCancel={wrapperPopupCancel}
                                            networkList={networkList}
                                            getNetworkList={getNetworkList}
                                            parentSetState={setState}
                                        />
                                    }
                                </Modal>
                            </ActionItemsContainer>
                            </Col>
                            <Col sm={{ size: 6 }} style={{"padding-right":"0px"}}>
                                <div className="searchInput" style={{ float: 'right' }}>
                                    <Label className='SearchLabel' >{getLabel("Search") ? getLabel("Search") : "Search"}</Label>
                                    <span className="pm_outersearchbox" >
                                        <input id="search-input" type="text" className="pm_searchbox" style={{ paddingLeft: '10px', 'margin-top': '3px' }} placeholder="Enter Value..." onChange={searchUpdated} value={state.searchTerm}/>
                                    </span>
                                    <label id="pagination-label" className="child_tab_paginationtext">{GetPaginationText()}</label>
                                </div>
                            </Col>
                        </FormGroup>
                    </Form>
                    <div className="table_container">
                        <Table id="table_Holidays" striped responsive className="Custom_table table_border">
                            <tbody className="cell_container tenant_cell">
                                <tr>
                                    <th className="link_cursor" style={{ padding: "9px" }} onClick={() => { onSort('networkName') }} >

                                        {getLabel("Name") ? getLabel("Name") : "Name"}
                                        <span className={(state.sort !== undefined && state.sort.direction[0] !== undefined && state.sort.direction[0].name === "networkName") ?
                                            (state.sort.direction[0].onclick) ? (state.sort.direction[0].direction === "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                                : (state.sort.direction[0].direction === "desc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                        </span>
                                    </th>
                                    <th className="link_cursor" style={{ padding: "9px" }} onClick={() => { onSort('isNodeConnected') }}>

                                        {getLabel("ConnectionStatus") ? getLabel("ConnectionStatus") : "Connection Status"}
                                        <span className={(state.sort !== undefined && state.sort.direction[1] !== undefined && state.sort.direction[1].name === "isNodeConnected") ?
                                            (state.sort.direction[1].onclick) ? (state.sort.direction[1].direction === "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                                : (state.sort.direction[1].direction === "desc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                        </span>
                                    </th>
                                    <th className="link_cursor" style={{ padding: "8px 10px" }} onClick={() => { onSort('mode') }}>
                                        {getLabel("Mode") ? getLabel("Mode") : "Mode"}
                                        <span className={(state.sort !== undefined && state.sort.direction[2] !== undefined && state.sort.direction[2].name === "mode") ?
                                            (state.sort.direction[2].onclick) ? (state.sort.direction[2].direction === "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                                : (state.sort.direction[2].direction === "desc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                        </span>

                                    </th>
                                    <th className="link_cursor" style={{ padding: "9px" }} onClick={() => { onSort('siteName') }}>

                                        {getLabel("BuildingName") ? getLabel("BuildingName") : "Building Name"}
                                        <span className={(state.sort !== undefined && state.sort.direction[3] !== undefined && state.sort.direction[3].name === "siteName") ?
                                            (state.sort.direction[3].onclick) ? (state.sort.direction[3].direction === "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                                : (state.sort.direction[3].direction === "desc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                        </span>
                                    </th>
                                    <th className="link_cursor" style={{ padding: "8px 10px" }} onClick={() => { onSort('endPointUrl') }}>

                                        {getLabel("ConnectedHubURL") ? getLabel("ConnectedHubURL") : "Connected Hub URL"}
                                        <span className={(state.sort !== undefined && state.sort.direction[4] !== undefined && state.sort.direction[4].name === "endPointUrl") ?
                                            (state.sort.direction[4].onclick) ? (state.sort.direction[4].direction === "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                                : (state.sort.direction[4].direction === "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                        </span>
                                    </th>
                                    <th></th>
                                </tr>
                                {
                                    FormTableData()
                                }
                            </tbody>
                        </Table>
                    </div>
                    <div className="row row_padding pm_pagination" style={{
                        borderBottom: '1px solid #999999',
                        borderLeft: '1px solid #999999',
                        borderRight: '1px solid #999999',
                        marginLeft: '0px',
                        marginRight: '0px'
                    }} >
                        <div className="col-md-6">
                            <ReactPaginate
                                id="pagination-text"
                                previousLabel={'Prev'}
                                nextLabel={'Next'}
                                breakLabel={'...'}
                                breakClassName={'break-me pagination_margin'}
                                breakLinkClassName={'pagination_link_color'}
                                pageCount={pagesCount}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={10}
                                onPageChange={handlePageClick}
                                containerClassName={'pagination pagination_container_margin'}
                                subContainerClassName={'pages pagination'}
                                activeClassName={'active'}
                                disabledClassName={'pagination_disable_link'}
                                pageClassName={'pagination_margin'}
                                pageLinkClassName={'pagination_link_color'}
                                previousClassName={'pagination_margin'}
                                previousLinkClassName={'pagination_link_color'}
                                nextClassName={pagesCount ? 'pagination_margin': 'pagination_margin pagination_disable_link'}
                                nextLinkClassName={'pagination_link_color'}
                                forcePage={state.currentPage}
                            />
                        </div>
                    </div>
                    {
                        state.apiError ? <ErrorSection>
                            <FormErrorContainer>
                                <MdWarning />
                                <b>{state.apiError}</b>
                            </FormErrorContainer>
                            <div>
                                <MdClose id="close-icon" onClick={() => setState(prevState => ({ ...prevState, apiError: "" }))} />
                            </div>
                        </ErrorSection> : null
                    }
                    {state.loading ? <SpinnerContainer>
                        <Spinner />
                    </SpinnerContainer> : null
                    }
                    <Form>
                        <FormGroup>
                            <Col sm={{ size: 4 }} style={{ "margin-left": "-19px" }}>
                                <CloseButton id="back-button" mr="0" mt="15px" variant="contained" onClick={() => history.goBack()}><FaArrowLeft />{getLabel("Back") ? getLabel("Back") : " Back"}</CloseButton>
                            </Col>
                        </FormGroup>
                    </Form>
                </>
            }
            <Idle timeout={state.LogOffTime} onChange={({ idle }) => {
                if (idle) {
                    setState(prevState => ({...prevState, inactive_modal: true}))
                }
            }} />
            <Modal isOpen={state.inactive_modal} className={"ModalContainer InActive_Short_Modal"} >
                <InactiveWindow Extend_Session={Extend_Session} />
            </Modal>
        </div>
    );
};

export default withRouter(ManageSecureConnect);